import { listIndeedFlexJobShifts } from 'api/admin/indeedFlex/listIndeedFlexJobShifts'
import { listIndeedFlexShiftIssues } from 'api/admin/indeedFlex/listIndeedFlexShiftIssues'
import { listIndeedFlexLongTermAssignmentPreview } from 'api/admin/indeedFlex/listIndeedFlexLongTermAssignmentPreview'

const indeedFlexKey = ['indeedFlex'] as const

export const indeedFlexKeys = {
  all: indeedFlexKey,
  authStatus: () => [...indeedFlexKey, 'authStatus'] as const,
  clients: () => [...indeedFlexKey, 'clients'] as const,
  companies: () => [...indeedFlexKey, 'companies'] as const,
  shiftIssues: () => [...indeedFlexKey, 'shiftIssues'] as const,
  shiftIssuesList: (params?: Parameters<typeof listIndeedFlexShiftIssues>[0]) =>
    [
      ...indeedFlexKeys.shiftIssues(),
      params?.page,
      params?.pageSize,
      params?.daysAgo,
      params?.ifClientIds,
      params?.companyIds,
      params?.issues,
    ] as const,
  jobShifts: () => [...indeedFlexKey, 'jobShifts'] as const,
  jobShiftsList: (params?: Parameters<typeof listIndeedFlexJobShifts>[0]) =>
    [...indeedFlexKeys.jobShifts(), params?.ifJobId] as const,
  longTermAssignmentPreview: (
    params?: Parameters<typeof listIndeedFlexLongTermAssignmentPreview>[0]
  ) =>
    [
      ...indeedFlexKey,
      'longTermAssignmentPreview',
      params?.ifClientId,
      params?.ifJobId,
    ] as const,
}
